import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const iconsPageEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(/* webpackChunkName: "async-insight-global-configuration-icons-tab" */ './index.tsx'),
	),
	getPreloadProps: () => ({}),
});
